
// eslint-disable-next-line import/prefer-default-export

import { httpGet } from "../store/externalCalls/httpCalls";

/**
 * Create a url with params store in a object session
 * @param {*} session
 * @param [string] sessionParams
 * @param string url
 */
export const composeURL = (objectWithData, params, url, id = undefined) => {
  let newURL = typeof url === 'object' && url !== null ? url.path : url;
  if(params){
    params.forEach((param) => {
      newURL = newURL.replace(param, objectWithData[param]);
    });
  }

  if (id !== undefined) {
    if(newURL.includes("/id/")){
      newURL = newURL.replace("/id/", `/${id}/`);
    }else{
      newURL += `/${id}`;
    } 
  }
  return newURL;
};
export const composeURLByQuery = (objectWithData, params, url, id = undefined) => {
  let newURL = composeURL(objectWithData, params, url, id);

  if (!params) {
    return newURL;
  }

  const queryParams = {};

  params.forEach((param) => {
    if (url.includes(param)) {
      return;
    }

    const value = objectWithData[param];

    if (value !== undefined && value !== null && value !== '') {
      queryParams[param] = value;
    }
  });

  const query = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${Array.isArray(value) ? value.join(',') : value}`)
    .join('&');

  return query ? `${newURL}?${query}` : newURL;
};

/**
 * Append array params to specific url
 * @param {} url to appen params
 * @param {*} params object with the params
 */
export const appendParamsToURL = (url, params) => {
  let newURL = url.includes('?') === true ? url : `${url}?`;
  Object.keys(params).forEach((indexParam, index) => {
    if(params[indexParam].length > 0){
      newURL += `${indexParam}=${params[indexParam]}`;
      if (index < Object.keys(params).length - 1) {
        newURL += '&';
      }
    } 
  });
  return newURL;
};

/**
 * Check if array items are in a object
 * @param {*} objectToCheck
 * @param [string] sessionParams
 */
export const checkObjectAttributes = (objectToCheck, params) => {
  if (params) {
    for (let i = 0; i < params.length; i += 1) {
      // console.log(params[i],objectToCheck);
      if (objectToCheck[params[i]] === undefined) {
        return false;
      }
    }
  }

  return true;
};

/**
 * Check if array items are in a object and stateObject
 * @param {*} objectToCheck
 * @param [string] sessionParams
 * @param {*} sessionState
 * @param {Function} setSessionState
 */
export const checkObjectAttributesAndSessionParams = (objectToCheck, params, sessionState = {}, setSessionState) => {
  if(Object.values(sessionState).length === 0){
    let objectParams = {};
    for (let i = 0; i < params.length; i++) {
      const key = params[i];
      objectParams[key] = objectToCheck[key];
    }
    setSessionState(objectParams);
    return false;
  }

  for (let i = 0; i < params.length; i += 1) {
    if (objectToCheck[params[i]] !== sessionState[params[i]]) {
      setSessionState({ ...sessionState, [params[i]]: objectToCheck[params[i]] });
      return false;
    }
  }
  
  return true;
};
/**
 * Remove the endpoints of a url
 * @param {string} fullURL
 */
export const getPartialPath = (fullURL) => fullURL.substr(
  fullURL.indexOf(
    process.env.REACT_APP_API_ENDPOINT,
  ) + process.env.REACT_APP_API_ENDPOINT.length,
);

/**
 * Get the string params of a specific url
 * @param {string} url
 */
export const getURLParams = (url) => url.substr(url.lastIndexOf('?'));

export const randomString = (length = 8) => {
  // Declare all characters
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  // Pick characers randomly
  let str = '';
  for (let i = 0; i < length; i++) {
      str += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return str;

};

export const LoadDownloadableImageFile=(downloadableId)=>{
  var promise = new Promise( (resolve, reject) => {
    if(downloadableId!=null){
      let url= "downloadableUrl/"+downloadableId;
      httpGet(url).then((res)=>{
        resolve(res);
      }).catch(error=>{
        console.log("Error loading images "+downloadableId);
        resolve(null);
      });
    }else
      resolve(null);
  });
  return promise;

}
